import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    gap: theme.spacing.space12,
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    zIndex: theme.zIndex.normal,
  },
  card: {
    position: "relative",
    width: 104,
    minWidth: 104,
    minHeight: 168,
    height: 168,
    "&.endscreen": {
      width: 78,
      height: 126,
      minHeight: 126,
      minWidth: 78,
    },
  },
  layer: {
    position: "absolute",
    height: "100%",
    width: "100%",
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0.45) 100%)",
    borderRadius: theme.radius.small,
  },
  gameImg: {
    width: "-webkit-fill-available",
    height: "100%",
    borderRadius: theme.radius.small,
  },
  rank: {
    position: "absolute",
    top: theme.spacing.space12,
  },
  rankText: {
    position: "absolute",
    top: 0,
    width: "100%",
    textAlign: "center",
    textShadow: "1px 1px 0px #0000004D",
  },
  gems: {
    position: "absolute",
    bottom: 0,
    right: 0,
    background: "rgba(0, 0, 0, 0.45)",
    width: 44,
    height: 44,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: `${theme.radius.small}px 0px`,
  },
  gemImg: {
    height: 25,
    width: 29,
  },
}));
